<template>
  <div class="timeline">
    <div class="row line desktop">
      <div class="column">
        <div class="point green ripple"></div>
      </div>
      <div class="column">
        <div class="point yellow"></div>
      </div>
      <div class="column">
        <div class="point green"></div>
      </div>
    </div>
    <div class="row">
      <div class="column">
        <AboutUsTimeLineItem
          class="item"
          year="1992"
          label="創始"
          description="創立於台中市西區三民路一段170號4樓"
        />
      </div>
      <div class="column">
        <AboutUsTimeLineItem
          class="item"
          year="2003"
          label="第一志願"
          description="台中市居仁國中資優班(第一志願)錄取30名學生，本班學生占23名"
        />
      </div>
      <div class="column">
        <AboutUsTimeLineItem
          class="item"
          year="2004"
          label="集中式資優班"
          description="台中市公立國中集中式資優班共錄取90名學生，本班學生占60名
台中市公立國小集中式資優班共錄取90名學生，本班學生占50名"
        />
      </div>
    </div>
    <div class="row line desktop">
      <div class="column">
        <div class="point yellow"></div>
      </div>
      <div class="column">
        <div class="point green"></div>
      </div>
      <div class="column">
        <div class="point yellow"></div>
      </div>
    </div>
    <div class="row">
      <div class="column">
        <AboutUsTimeLineItem
          class="item"
          year="2006"
          label="成立分校"
          description="於南屯區河南路四段372號成立第一個分校"
        />
      </div>
      <div class="column">
        <AboutUsTimeLineItem
          class="item"
          year="2007"
          label="成立「國中部」"
          description="於西區三民路一段172-6號成立「國中部」"
        />
      </div>
      <div class="column">
        <AboutUsTimeLineItem
          class="item"
          year="2011"
          label="成立「高僑總部」及「南屯校」"
          description="於南屯區河南路四段538號買地自建成立「高僑總部」及「南屯校」"
        />
      </div>
    </div>
    <div class="row line desktop">
      <div class="column">
        <div class="point green"></div>
      </div>
      <div class="column">
        <div class="point yellow"></div>
      </div>
      <div class="column">
        <div class="point green"></div>
      </div>
    </div>
    <div class="row">
      <div class="column">
        <AboutUsTimeLineItem
          class="item"
          year="2012"
          label="成立「西屯校」"
          description="於西屯區上安路41號成立「西屯校」"
        />
      </div>
      <div class="column">
        <AboutUsTimeLineItem
          class="item"
          year="2013"
          label="開放加盟"
          description="開始推廣加盟制度"
        />
      </div>
      <div class="column">
        <AboutUsTimeLineItem
          class="item"
          year="2018"
          label="成立「高中部」"
          description="於三民路一段166-2號正式成立「高中部」"
        />
      </div>
    </div>
    <div class="row line desktop">
      <div class="column">
        <div class="point yellow"></div>
      </div>
      <div class="column">
        <div class="point green"></div>
      </div>
      <div class="column">
        <div class="point yellow "></div>
      </div>
    </div>
    <div class="row">
      <div class="column">
        <AboutUsTimeLineItem
          class="item"
          year="2008~2022"
          label="私中考試成績優異"
          description="台中市私中入學考試，本機構小六學生表現傑出，獨霸中部地區，囊括各私中前十名榜單，衛道、曉明、明道錄取人數逐年成長"
        />
      </div>
      <div class="column">
        <AboutUsTimeLineItem
          class="item"
          year="2022"
          label="成立「達人數理」新品牌"
          description="為因應區域性的學習需求，服務更廣大的學生族群，走入學區進⾏教育服務"
        />
      </div>
      <div class="column">
        <AboutUsTimeLineItem
          class="item"
          year="2021、2023"
          label="擴大加盟"
          description="完成彰化區域加盟版圖，北有「泰和校」、南有「南郭校」，協力資優教育服務"
        />
      </div>
    </div>
    <div class="row line desktop">
      <div class="column">
        <div class="point green ripple"></div>
      </div>
      <div class="column">
        <div class="point yellow"></div>
      </div>
      <div class="column">
        <div class="point green"></div>
      </div>
    </div>
    <div class="row">
      <div class="column">
        <AboutUsTimeLineItem
          class="item"
          year="2024"
          label="成立「達⼈數理」分校"
          description="於南屯區⼤隆路93號成立第⼆間達⼈數理分校「東興校」"
        />
      </div>
      <div class="column"></div>
      <div class="column"></div>
    </div>
  </div>
</template>

<script>
import AboutUsTimeLineItem from "@/components/AboutUsTimeLineItem.vue";

export default {
  components: {
    AboutUsTimeLineItem
  }
};
</script>

<style lang="scss" scoped>
.timeline {
  .row {
    display: flex;
    justify-content: space-around;

    .column {
      width: 33.333333%;
      display: flex;
      justify-content: center;
    }
  }

  .line {
    position: relative;
    height: 32px;
    align-items: center;
    &:before {
      content: "";
      display: block;
      height: 1px;
      width: 100%;
      display: block;
      background-color: #63abcd;
      position: absolute;
      top: 50%;
      z-index: -1;
    }
  }

  .point {
    width: 15px;
    height: 15px;
    border-radius: 100%;

    &.ripple {
      width: 20px;
      height: 20px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      &:before {
        content: "";
        width: 24px;
        height: 24px;
        border-radius: 100%;
        display: block;
        display: block;
        position: absolute;
        border: 2px solid #000;
        opacity: 0.6;
      }
      &:after {
        content: "";
        width: 32px;
        height: 32px;
        border-radius: 100%;
        display: block;
        display: block;
        position: absolute;
        border: 3px solid #000;
        opacity: 0.3;
      }
    }

    &.green {
      background-color: #cde000;
      &:before,
      &:after {
        border-color: #cde000;
      }
    }

    &.yellow {
      background-color: #f1d85b;
      &:before,
      &:after {
        border-color: #f1d85b;
      }
    }
  }

  .item {
    margin: 20px 0;
  }
}

@media (max-width: 1023px) {
  .row {
    flex-direction: column !important;

    .column {
      width: 100% !important;
    }
  }
}
</style>
